webpackJsonp([79611799117203,60335399758886],{

/***/ 134:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(395);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(134);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 384:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(9);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactstrap = __webpack_require__(10);
	
	var _FooterGroup = __webpack_require__(385);
	
	var _FooterGroup2 = _interopRequireDefault(_FooterGroup);
	
	var _FooterGroupItem = __webpack_require__(386);
	
	var _FooterGroupItem2 = _interopRequireDefault(_FooterGroupItem);
	
	__webpack_require__(741);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    "div",
	    { className: "footer container-fluid" },
	    _react2.default.createElement(
	      _reactstrap.Row,
	      { className: "sitemap" },
	      _react2.default.createElement(_reactstrap.Col, { xs: "0", lg: "2" }),
	      _react2.default.createElement(
	        _reactstrap.Col,
	        { xs: "6", lg: "2" },
	        _react2.default.createElement(
	          _FooterGroup2.default,
	          { title: "Products" },
	          _react2.default.createElement(
	            _FooterGroupItem2.default,
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/products/realfire" },
	              "Realfire"
	            )
	          ),
	          _react2.default.createElement(
	            _FooterGroupItem2.default,
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/products/scheduleright" },
	              "Scheduleright"
	            )
	          ),
	          _react2.default.createElement(
	            _FooterGroupItem2.default,
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/products/realsync" },
	              "Realsync"
	            )
	          ),
	          _react2.default.createElement(
	            _FooterGroupItem2.default,
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/products/libshare" },
	              "Libshare"
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _reactstrap.Col,
	        { xs: "6", lg: "2" },
	        _react2.default.createElement(
	          _FooterGroup2.default,
	          { title: "Company" },
	          _react2.default.createElement(
	            _FooterGroupItem2.default,
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/company/about" },
	              "About Us"
	            )
	          ),
	          _react2.default.createElement(
	            _FooterGroupItem2.default,
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/company/contact" },
	              "Contact"
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _reactstrap.Col,
	        { xs: "6", lg: "2" },
	        _react2.default.createElement(
	          _FooterGroup2.default,
	          { title: "Resources" },
	          _react2.default.createElement(
	            _FooterGroupItem2.default,
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/resources/docs" },
	              "Product Docs"
	            )
	          ),
	          _react2.default.createElement(
	            _FooterGroupItem2.default,
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/resources/support" },
	              "Support"
	            )
	          ),
	          _react2.default.createElement(
	            _FooterGroupItem2.default,
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/resources/eula" },
	              "Realfire EULA"
	            )
	          ),
	          _react2.default.createElement(
	            _FooterGroupItem2.default,
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/resources/privacy" },
	              "Privacy Policy"
	            )
	          ),
	          _react2.default.createElement(
	            _FooterGroupItem2.default,
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/resources/credits" },
	              "Credits"
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _reactstrap.Col,
	        { xs: "6", lg: "2" },
	        _react2.default.createElement(
	          _FooterGroup2.default,
	          { title: "Social" },
	          _react2.default.createElement(
	            _FooterGroupItem2.default,
	            null,
	            _react2.default.createElement(
	              "a",
	              { href: "https://twitter.com/datasert" },
	              "Twitter"
	            )
	          ),
	          _react2.default.createElement(
	            _FooterGroupItem2.default,
	            null,
	            _react2.default.createElement(
	              "a",
	              { href: "https://github.com/datasert" },
	              "Github"
	            )
	          ),
	          _react2.default.createElement(
	            _FooterGroupItem2.default,
	            null,
	            _react2.default.createElement(
	              "a",
	              { href: "https://www.linkedin.com/company/datasert" },
	              "LinkedIn"
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_reactstrap.Col, { xs: "0", lg: "2" })
	    ),
	    _react2.default.createElement(
	      _reactstrap.Row,
	      { className: "copyright" },
	      _react2.default.createElement(
	        _reactstrap.Col,
	        { xs: "12" },
	        "\xA9 2017 Datasert Inc. All Rights Reserved"
	      )
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports["default"];

/***/ }),

/***/ 741:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(9);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	__webpack_require__(742);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FooterGroup = function FooterGroup(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'footer-group' },
	        _react2.default.createElement(
	            'div',
	            { className: 'title' },
	            props.title
	        ),
	        _react2.default.createElement(
	            'ul',
	            null,
	            props.children
	        )
	    );
	};
	
	exports.default = FooterGroup;
	module.exports = exports['default'];

/***/ }),

/***/ 742:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(9);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	__webpack_require__(743);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FooterGroupItem = function FooterGroupItem(props) {
	    return _react2.default.createElement(
	        'li',
	        { className: 'footer-group-item' },
	        props.children
	    );
	};
	
	exports.default = FooterGroupItem;
	module.exports = exports['default'];

/***/ }),

/***/ 743:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 387:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(9);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactstrap = __webpack_require__(10);
	
	__webpack_require__(744);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header(props) {
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.toggle = _this.toggle.bind(_this);
	    _this.state = {
	      isOpen: false
	    };
	    return _this;
	  }
	
	  Header.prototype.toggle = function toggle() {
	    this.setState({
	      isOpen: !this.state.isOpen
	    });
	  };
	
	  Header.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        _reactstrap.Navbar,
	        {
	          light: true,
	          toggleable: "xs",
	          full: true,
	          className: "navbar-expand-lg navbar-expand-md"
	        },
	        _react2.default.createElement(
	          _reactstrap.NavbarBrand,
	          { href: "/" },
	          "Datasert"
	        ),
	        _react2.default.createElement(_reactstrap.NavbarToggler, { onClick: this.toggle }),
	        _react2.default.createElement(
	          _reactstrap.Collapse,
	          { isOpen: this.state.isOpen, navbar: true },
	          _react2.default.createElement(
	            _reactstrap.Nav,
	            { navbar: true },
	            _react2.default.createElement(
	              _reactstrap.NavItem,
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { className: "nav-link", to: "/products/realsync" },
	                "Realsync"
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.NavItem,
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { className: "nav-link", to: "/products/realfire" },
	                "Realfire"
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.NavItem,
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { className: "nav-link", to: "/products/scheduleright" },
	                "Scheduleright"
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.NavItem,
	              null,
	              _react2.default.createElement(
	                "span",
	                { className: "products-separator" },
	                "|"
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.NavItem,
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { className: "nav-link", to: "/products/realfire/pricing" },
	                "Pricing"
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.NavItem,
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { className: "nav-link", to: "/resources/docs" },
	                "Docs"
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.NavItem,
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { className: "nav-link", to: "/resources/support" },
	                "Support"
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.NavItem,
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { className: "nav-link", to: "/products/realfire/refer" },
	                "Refer Us"
	              )
	            ),
	            _react2.default.createElement(
	              "form",
	              { className: "form-inline my-2 my-lg-0" },
	              _react2.default.createElement(
	                _reactstrap.ButtonGroup,
	                null,
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  {
	                    to: "/products/realfire/buy",
	                    className: "btn btn-outline-success my-2 my-sm-0 btn-sm"
	                  },
	                  "Buy Realfire"
	                ),
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  {
	                    to: "/products/realfire",
	                    className: "btn btn-outline-success my-2 my-sm-0 btn-sm"
	                  },
	                  "Download Realfire"
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Header;
	}(_react2.default.Component);
	
	exports.default = Header;
	module.exports = exports["default"];

/***/ }),

/***/ 744:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 129:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 501:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 395:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(9);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(387);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(384);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _reactstrap = __webpack_require__(10);
	
	__webpack_require__(501);
	
	__webpack_require__(129);
	
	__webpack_require__(748);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TemplateWrapper = function TemplateWrapper(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    { style: { height: '100%' } },
	    _react2.default.createElement(
	      'div',
	      { className: 'wrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: 'header-row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container-fluid' },
	          _react2.default.createElement(_Header2.default, null)
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'body-row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container-fluid' },
	          children()
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'footer-row' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container-fluid' },
	        _react2.default.createElement(_Footer2.default, null)
	      )
	    )
	  );
	};
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports['default'];

/***/ }),

/***/ 748:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-jsx-dcf90cf3d2411df50c76.js